
export const endpoint: string = process.env.REACT_APP_API_ENDPOINT!;
